import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
const BlurryDialog = styled(Dialog)(({ theme }) => ({
    backdropFilter: 'blur(2px)',
}));
export const GenericDialog = (props) => {
    const [open, setOpen] = useState(props.open);
    const { content, title, onClose } = props;
    useEffect(() => {
        if (props.open != open) {
            setOpen(props.open);
        }
    }, [props.open]);
    const handleClose = () => {
        onClose && onClose();
        setOpen(false);
    };
    return _jsxs(BlurryDialog, { maxWidth: "lg", onClose: handleClose, open: open, transitionDuration: 0, children: [title && _jsx(DialogTitle, { sx: { minWidth: '350px', m: 0, p: 1, color: '#007ca3', textAlign: 'center' }, children: title }), _jsx(IconButton, { onClick: handleClose, sx: { position: 'absolute', right: 4, top: 4, color: theme => theme.palette.grey[500] }, children: _jsx(CloseIcon, {}) }), _jsx(DialogContent, { dividers: true, children: content })] });
};
